/**
 * WbFlag — vlag met dikke linkerrand voor iets dat gelezen moet worden.
 *
 * geld       rood: openstaand bedrag, betaling nodig
 * opmerking  oranje: klantopmerking, volledige tekst (nooit afkappen)
 * nieuw      mint: stop na de vergrendeling toegevoegd
 * info       inkt: berichten, op-factuur, neutrale melding
 */

import clsx from 'clsx';

export interface WbFlagProps {
  kind: 'geld' | 'opmerking' | 'nieuw' | 'info';
  title?: string;
  children?: React.ReactNode;
  /** Tikbaar: hele vlag wordt een knop (bv. opent de betaalmodal). */
  onClick?: () => void;
  className?: string;
}

const STIJL: Record<WbFlagProps['kind'], string> = {
  geld: 'bg-wb-geld border-l-wb-geldink text-wb-geldink',
  opmerking: 'bg-wb-opmerking border-l-wb-opmerkingrand text-wb-inkt',
  nieuw: 'bg-wb-mint border-l-wb-mintink text-wb-mintink',
  info: 'bg-wb-vlak border-l-wb-inkt text-wb-inkt',
};

export function WbFlag({ kind, title, children, onClick, className }: WbFlagProps) {
  const inhoud = (
    <>
      {title && <p className="font-wb-heading font-bold text-sm uppercase tracking-wide leading-tight">{title}</p>}
      {children && <div className={clsx('text-base leading-snug whitespace-pre-line', title && 'mt-0.5')}>{children}</div>}
    </>
  );
  const klassen = clsx('w-full text-left rounded-r-wb border-l-[6px] px-3 py-2 min-h-tap flex flex-col justify-center', STIJL[kind], className);
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={clsx(klassen, 'wb-focus')}>
        {inhoud}
      </button>
    );
  }
  return <div className={klassen}>{inhoud}</div>;
}
